module.exports = __webpack_public_path__ + "static/img/7.386f56c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/7.png
// module id = 6kAz
// module chunks = 0